import React from "react";
import SupportEmail from "../components/SupportEmail";

const CyberneticHardware = () => {
  return (
    <>
      <div className="cybernetic-container">
        <h1>Cybernetic Hardware</h1>
        
        <div className="promo-banner">
          <p>
            These devices are not yet launched. Early access is limited to verified partners through <strong> corporate@omegaopscyberdefence.com</strong> only.
             {/* See the Register/Login Page for 
            details on <span className="highlight">75% off</span> our cybernetic hardware! 
            Open to businesses and non-business entities alike. */}
          </p>
          <a href="https://omegaopscyberdefence.com/" className="banner-cta">Learn More</a>
        </div>
        
        <div className="hardware-intro">
          <p>
          Omega Ops Cybernetics Defence Corp. is developing cutting-edge cybernetic hardware. These
revolutionary devices will provide unprecedented levels of security and authentication while
maintaining our commitment to privacy and decentralization.
          </p>
        </div>
        
        <div className="hardware-showcase">
          <div className="hardware-item">
            {/* <div className="hardware-image-container">
              <div className="hardware-image vein-lock-image">
                <div className="placeholder-text">Omega Vein Lock&trade; Prototype</div>
              </div>
              <div className="image-overlay">
                <span className="patent-pending">Patent Pending</span>
              </div>
            </div> */}
            
            <div className="hardware-details">
              <h2>Omega Vein Lock&trade;</h2>
              <p>
                The Omega Vein Lock&trade; is an advanced biometric security device that uses 
                proprietary vascular mapping technology to create unhackable authentication. 
                Unlike traditional biometrics that store data in centralized databases, 
                Omega Vein Lock&trade; operates on a zero-knowledge system that never records or 
                transmits your actual biometric data.
              </p>
              <h3>Key Features:</h3>
              <ul>
                <li>Military-grade vascular pattern recognition</li>
                <li>Zero-knowledge authentication architecture</li>
                <li>Tamper-proof hardware design</li>
                <li>Offline capability with encrypted key storage</li>
              </ul>
   
              <div className="document-download">
                <a href="/documents/Figures_TPP90309.pdf" download="Omega_Void_Vein_Lock.pdf"  className="hardware-download-btn">
                  <span className="download-icon"></span>
                  Download Patent Illustration
                </a>
              </div>
            </div>
          </div>
          
          <div className="hardware-item">
            {/* <div className="hardware-image-container">
              <div className="hardware-image cyber-cap-image">
                <div className="placeholder-text">Omega CyberCap&trade; Prototype</div>
              </div>
              <div className="image-overlay">
                <span className="patent-pending">Patent Pending</span>
              </div>
            </div> */}
            
            <div className="hardware-details">
              <h2>Omega CyberCap&trade;</h2>
              <p>
                The Omega CyberCap&trade; represents the future of secure human-computer interaction. 
                This wearable neural interface device enables thought-based authentication and 
                communication while maintaining complete privacy. The CyberCap&trade; translates 
                neural patterns into secure tokens without ever recording or transmitting 
                actual thought content.
              </p>
              <h3>Key Features:</h3>
              <ul>
                <li>Non-invasive neural pattern recognition</li>
                <li>Thought-to-text encryption technology</li>
                <li>Hands-free secure messaging capability</li>
                <li>Anti-surveillance protection mechanisms</li>
                <li>Self-contained processing with no cloud dependency</li>
              </ul>
              <div className="document-download">
                <a href="/documents/Figures_TPP90446.pdf" download="Omega_Void_CyberCap.pdf"  className="hardware-download-btn">
                  <span className="download-icon"></span>
                  Download Patent Illustration
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="technical-documents">
          <h2>Technical Documentation</h2>
          <p>
            The provisional patent documents are available for review by 
            verified partners. To request access, please contact 
            <a href="mailto:corporate@omegaopscyberdefence.com"> corporate@omegaopscyberdefence.com</a>.
          </p>
          
          {/* <div className="document-grid">
            <div className="document-card">
              <div className="document-icon pdf-icon"></div>
              <div className="document-info">
                <h3>Omega Vein Lock&trade; Technical Specifications</h3>
                <p>Detailed hardware specifications and security architecture</p>
                <a href="#" className="document-link">Request Document</a>
              </div>
            </div>
            
            <div className="document-card">
              <div className="document-icon pdf-icon"></div>
              <div className="document-info">
                <h3>CyberCap&trade; Integration Protocol</h3>
                <p>API documentation for hardware-software integration</p>
                <a href="#" className="document-link">Request Document</a>
              </div>
            </div>
          </div> */}
        </div>
        
        <div className="early-access">
          <h2>Early Access Program</h2>
          <p>
            A limited number of prototype units will be made available to verified partners 
            through our Early Access Program. Participants will receive significant 
            discounts on final production units and direct access to our engineering team.
          </p>
          <a href="https://omegaopscyberdefence.com/#contact" className="access-button">Apply for Early Access</a>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default CyberneticHardware;